import(/* webpackMode: "eager", webpackExports: ["GovernmentLayout"] */ "/vercel/path0/apps/public/app/portal/[code]/government-layout.tsx");
